import React from "react";
import { useTranslation } from "@coworker/locales";
import userPreferences from "@coworker/enums/profilePreferences";
import { useMyStore } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useUserPreference } from "../hooks/useProfilePreferencesQuery";
import { getShellLanguage } from "../core/shellLanguage";

export function resolveCountryId(userCountryId, countryId, primaryLocale) {
  const countryCodefromMyStore = (countryId?.length === 2 && countryId) || "";
  return countryCodefromMyStore || primaryLocale?.slice(-2) || userCountryId;
}

export function useSetInitialLanguage() {
  const store = useMyStore();

  const [preferenceLanguage, , isLoading] = useUserPreference(
    userPreferences.LANGUAGE,
    store?.primaryLocale ?? ""
  );

  // When the Flexa shell provides a language via ShellContext.language it wins
  // over the backend user preference — the shell profile is the source of truth
  // in the embedded (MFE) case. Falls back to the preference when running
  // standalone (no shell language set).
  const shellLanguage = getShellLanguage();
  const userLanguage = shellLanguage ?? preferenceLanguage;
  const resolving = shellLanguage ? false : isLoading;

  const { changeLanguage, language: activeLang = "" } = useTranslation();
  // Todo: remove this flag when we have a proper solution, talk to Mange about it
  //const blablaLanguage = useFlag(FLAGS.BLABLA_LANGUAGE);

  React.useEffect(() => {
    if (!resolving && userLanguage && userLanguage !== activeLang) {
      changeLanguage(userLanguage);
    }
  }, [changeLanguage, activeLang, userLanguage, resolving]);
}
